import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'eddydata-lib';
import { ProdutoLocalizacaoFormComponent } from './produto-localizacao-form/produto-localizacao-form.component';
import { ProdutoLocalizacaoListComponent } from './produto-localizacao-list/produto-localizacao-list.component';
import { ProdutoLocalizacaoViewComponent } from './produto-localizacao-view/produto-localizacao-view.component';

const routes: Routes = [
  { path: '', component: ProdutoLocalizacaoListComponent, canActivate: [AuthGuard] },
  { path: 'novo', component: ProdutoLocalizacaoFormComponent, canActivate: [AuthGuard] },
  { path: ':id/editar', component: ProdutoLocalizacaoFormComponent, canActivate: [AuthGuard] },
  { path: ':id/visualizar', component: ProdutoLocalizacaoViewComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProdutoLocalizacaoRoutingModule { }
